import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";

export const Loading = ({ size = 48, label }) => (
  <div
    className="container_loader"
    role={label ? "status" : undefined}
    aria-live={label ? "polite" : undefined}
  >
    <div
      className="loader"
      style={{ width: size, height: size }}
      aria-hidden="true"
    ></div>
    {label && <span className="sr-only">{label}</span>}
  </div>
);

Loading.propTypes = {
  size: PropTypes.number,
  label: PropTypes.string,
};
